import React from 'react'
import { Parallax } from 'react-parallax'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { mobileAbout, about, aboutText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <Parallax bgImage={mobileAbout} bgImageAlt="Entree Dish" strength={100}>
          <div style={{ height: '500px' }} />
        </Parallax>
        {/* <CFView
          column
          center
          h="500px"
          image={`url(${mobileAbout}) center / cover no-repeat`}
          style={{ backgroundAttachment: 'fixed' }}
        >
          <CFImage src={about} w="100%" alt="About" />
        </CFView> */}
      </MobileScreen>
      <DefaultScreen>
        <CFView column center>
          <CFView
            row
            justifyStart
            alignCenter
            pv="10%"
            pr="40px"
            h="600px"
            w="100%"
            maxWidth="1400px"
            image={`url(${about}) bottom / cover no-repeat`}
            style={{ backgroundAttachment: 'fixed' }}
          >
            {/* <CFImage src={aboutText} h="600px" alt="About" /> */}
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
